export const DEPOSIT = 'Deposit';

export const WITHDRAWAL = 'Withdrawal';

export const ACCOUNT_TRANSFER = 'AccountTransfers';

export const BANK_LINKS = 'BankLinks';

export const STATUS = {
  IN_PROCESS: 'In Process',
  AWAITING_CLIENT_CONFIRMATION: 'Awaiting Client Confirmation',
  AWAITING_MICRODEPOSIT_VERIFICATION: 'Awaiting Microdeposit Verification',
  AUTOMATED_MICRODEPOSIT_VERIFICATION_PENDING: 'Awaiting Microdeposit Verification Pending',
  DOCUMENTATION_REQUIRED: 'Documentation Required',
  LIQUIDATION_INITIATED: 'Liquidation Initiated',
  LIQUIDATION_COMPLETE: 'Liquidation Complete',
  PENDING_REVIEW: 'Pending Review',
  PENDING_VERIFICATION: 'Pending Verification',
  SCHEDULED: 'Scheduled',
  ALL: 'All',
  COMPLETE: 'Complete',
  PENDING: 'Pending',
  APPROVED: 'Pending',
  FUNDS_POSTED: 'Pending',
  CANCELED: 'Canceled',
  REJECTED: 'Canceled',
  RETURNED: 'Returned',
  SENT_TO_BANK: 'Pending',
  FAILED_AT_BANK: 'Canceled',
  COMPLETE_RESTRICTED: 'Pending',
  PENDING_BROKER_APPROVAL: 'Pending',
  VOID: 'Canceled',
  STOP_PAYMENT: 'Canceled',
  PENDING_PRINTING: 'Pending',
  REJECTED_FUNDS_NOT_POSTED: 'Rejected',
  REJECTED_UNAPPROVED: 'Rejected',
  FROZEN: 'Pending',
  REQUESTED: 'Pending',
  REJECTED_VALIDATION_FAILED: 'Rejected',
};

export const PLAID_ERROR_CODE = {
  ITEM_LOGIN_REQUIRED: 'ITEM_LOGIN_REQUIRED',
  INVALID_ACCOUNT_ID: 'INVALID_ACCOUNT_ID',
};

export const TRANSFERDIRECTIONID = {
  DEPOSIT: 1,
  WITHDRAWAL: 2,
};

export const TRANSFER_INITIATED_FROM_ID = {
  CLIENT: 1,
  ADVISOR_THEN_CLIENT: 3,
};

export const PRETAX = 'pretax';

export const POSTTAX = 'posttax';

export const FREQUENCY = {
  ONETIME: 'One-Time',
  WEEKLY: 'Weekly',
  MONTHLY: 'Monthly',
  QUARTERLY: 'Quarterly',
  ANNUALLY: 'Annually',
};

export const MAXLINKCOUNT = 5;

export const LINKINGTYPE = {
  MICRODEPOSIT: 'Microdeposit',
  PLAID: 'Plaid',
};

export const TRANSFERREQUEST = {
  COMPLETE: 1,
  REQUESTED: 2,
  CLIENT_COMPLETE: 3,
  CANCEL: 4,
};

export const ACCT_TYPES_THAT_HAVE_ONE_CONTRIB_TYPE = ['TRADITIONAL_IRA', 'ROTH_IRA'];

export const ACCT_TYPES_THAT_IGNORE_TAX_CUTOFF = ['SEP_IRA', 'SIMPLE_IRA'];

export const ACCOUNT_TAX_ID = Object.freeze({
  TAX_ADVANTAGED: 3,
});

export const TRANSFER_INITIATED_FROM_CODES = {
  advisor: 'ADVISOR',
};

export const NEW_PLAID_ACCOUNT_ID = 'new bank account';

export const MICRO_DEPOSIT_PENDING_ACCOUNT_NAME = 'Bank Account (Validation Pending)';

export const TRANSFER_NOT_EDITABLE_MESSAGE =
  'Sorry, this transfer cannot be edited at this time.  Please try again later or set up a new transfer.';

export const MAX_PERCENT_WITHHOLDING_MESSAGE =
  'The sum of Federal and State Withholding percentages cannot be greater than 100';

export const maxDollarWithholdingMessage = (amount) =>
  `The sum of Federal and State Withholding cannot be greater than the transfer amount ${amount}`;

export const WITHHOLDING_O_10_100 = 'Federal Tax Withholding must be a value between 10% and 100%';

export const WITHHOLDING_BETWEEN_1_100 = 'Federal Tax Withholding must be a value between 1% and 100%';

export const STATE_WITHHOLDING_BETWEEN_1_100 = 'The State Tax Withholding percentage must be between 0 and 100';

export const CANCEL_BANNER_MESSAGE = 'Transaction can no longer be canceled';

export const CANCEL_ERROR_MESSAGE = 'An error occurred when trying to cancel. Please try again.';

export const SCHEDULED_DEFAULT_VIEW_MESSAGE = 'You have no scheduled transfers';

export const COMPLETED_DEFAULT_VIEW_MESSAGE = 'You have no completed transfers';

export const BANK_LINK_WARNING_MESSAGE = [
  'The bank account which you have selected needs to be relinked, kindly',
  'click here,',
  'to relink your bank account.',
];
